import type AggregationWidgetConfig from 'views/logic/aggregationbuilder/AggregationWidgetConfig';
import type View from 'views/logic/views/View';
import type { AssistantRequest } from 'ai/types';
import type Widget from 'views/logic/widgets/Widget';

const groupByForWidget = (config: AggregationWidgetConfig) => {
  if (!config) {
    return [];
  }

  const rowPivots = config.rowPivots.map((pivot) => ({ type: 'row', fields: pivot.fields }) as const);
  const columnPivots = config.columnPivots.map((pivot) => ({ type: 'column', fields: pivot.fields }) as const);

  return [...rowPivots, ...columnPivots];
};

const metricsForWidget = (config: AggregationWidgetConfig) => {
  if (!config) {
    return [];
  }

  return config.series.map((series) => ({ function: series.function, name: series.effectiveName }));
};

const createWidgetSummaryRequest = (view: View, widget: Widget, widgetResult): AssistantRequest => {
  const widgetTitle = view.getWidgetTitleByWidget(widget);
  const headers = widgetResult?.chart?.column_names ?? [];
  const rows = (widgetResult?.chart?.rows ?? [])
    .filter((r) => r.source === 'leaf')
    .flatMap((r) => r.values.map((subRow) => [[...r.key, ...subRow.key].join('.'), subRow.value]));

  return {
    type: 'widget',
    payload: {
      name: widgetTitle,
      description: widget.description,
      context: widget.context,
      config: {
        type: 'aggregation',
        group_by: groupByForWidget(widget.config),
        metrics: metricsForWidget(widget.config),
      },
      data: {
        headers,
        rows,
      },
    },
  };
};
export default createWidgetSummaryRequest;
